import { useLiveClassList } from 'hooks/liveClasses';
import LiveClassesList from './components/LiveClassesList';

const ListLiveClasses = () => {
  const { data, isLoading, isFetching, refetch, error } = useLiveClassList();

  const liveClassesList = data?.data;
  const loading = isLoading || isFetching;

  return (
    <div className="w-100">
      <h3>Live Classes List</h3>

      <LiveClassesList
        liveClassesList={liveClassesList || []}
        refetch={refetch}
        loading={loading}
        error={error}
      />
    </div>
  );
};

export default ListLiveClasses;
